<script setup lang="ts">

import ThemeEditor from "@/pages/Settings/AppConfigurationPage/components/ThemeConfigForm.vue";
import ImageEditor from "@/pages/Settings/AppConfigurationPage/components/ImageEditor.vue";
import FontAppConfigurationSection from "@/pages/Settings/AppConfigurationPage/components/FontAppConfigurationSection.vue";
import DesignSystemVariables from "@/pages/Settings/AppConfigurationPage/components/DesignSystemVariables.vue";
</script>

<template>
  <theme-editor />
  <div class="mt-4">
    <design-system-variables />
  </div>
  <div class="mt-4">
    <image-editor/>
  </div>
  <div class="mt-4">
    <font-app-configuration-section />
  </div>

</template>
